import en from './en-US';
import jp from './ja-JP';


export default {
    ...en,
    ...jp,
};